import { Routes } from '@angular/router';
import { sceneLayoutResolver } from '@board/scene-layout/scene-layout.resolver';
import { UserRole } from '@shared/types/user';
import { checkPermissionGuard } from '../guards/check-permission.guard';
import { loggedInAuthGuard } from '../guards/is-logged-in.guard';

export const BOARD_ROUTES: Routes = [
  {
    path: 'board-games',
    loadComponent: () =>
      import('@board/games/board-games/board-games.component').then(
        (m) => m.BoardGamesComponent,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
  {
    path: 'board-labels/:gameUuid',
    loadComponent: () =>
      import('@board/labels/board-labels/board-labels.component').then(
        (m) => m.BoardLabelsComponent,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
  {
    path: 'scene-layout/:stageUuid',
    loadComponent: () =>
      import('@board/scene-layout/scene-layout.component').then(
        (m) => m.SceneLayoutComponent,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
    resolve: {
      stage: sceneLayoutResolver,
    },
  },
  {
    path: 'board-stages',
    loadComponent: () =>
      import('@board/stages/board-stages/stages.component').then(
        (m) => m.StagesComponent,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
  {
    path: 'board-theme',
    loadComponent: () =>
      import('@board/theme/board-theme/board-theme.component').then(
        (m) => m.BoardThemeComponent,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin, UserRole.ClientAdmin],
    },
  },
  {
    path: 'path-config',
    loadComponent: () =>
      import('@board/paths/path-config/path-config.component').then(
        (m) => m.PathConfigComponent,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
  {
    path: 'actions-config',
    loadComponent: () =>
      import('@board/actions/actions-config/actions-config.component').then(
        (m) => m.ActionsConfigComponent,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
  {
    path: 'board-collectibles',
    loadComponent: () =>
      import('@board/collectibles/board-collectibles/board-collectibles.component').then(
        (m) => m.BoardCollectiblesComponent,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
  {
    path: 'board-preview',
    loadComponent: () =>
      import('@board/board-preview/board-preview.component').then(
        (m) => m.BoardPreviewComponent,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin],
    },
  },
];
